import { TAnswer } from 'shared/types/faq';
import { Row } from '../Row';

interface IBlockProps {
  content: TAnswer[];
  onLinkClick?: (link: string) => void;
}

export const Block: React.FC<IBlockProps> = ({ content, onLinkClick }) => {
  return (
    <p>
      {content.map((row, index) => (
        <Row key={index} content={row} onLinkClick={onLinkClick} />
      ))}
    </p>
  );
};
